// The 422 the monolith renders when a select-all bulk action resolves well
// more applicants than the table showed. Nothing ran; Hire's message says how
// many it found and what to do.

// Mirrored against ApiSelfServe::V2::BulkActionsController::
// SELECT_ALL_COUNT_EXCEEDED_ERROR_TYPE in apps/hire through
// tools/contract-mirrors/mirrors.json.
export const SELECT_ALL_COUNT_EXCEEDED_ERROR_TYPE = 'select_all_count_exceeded';

// What the axios interceptor rejects with when the response body carries
// `error_type: 'select_all_count_exceeded'`.
export interface SelectAllCountRefusal {
  errorType: typeof SELECT_ALL_COUNT_EXCEEDED_ERROR_TYPE;
  message: string;
}

export function isSelectAllCountRefusal(
  value: unknown,
): value is SelectAllCountRefusal {
  if (value == null || typeof value !== 'object') {
    return false;
  }
  const candidate = value as { errorType?: unknown; message?: unknown };
  return (
    candidate.errorType === SELECT_ALL_COUNT_EXCEEDED_ERROR_TYPE &&
    typeof candidate.message === 'string'
  );
}

// Hire takes the select-all path when `applicant_ids` is blank, an empty array
// included, and treats `selected_by_count` as its own mode. Only a select-all
// carries the count.
export function isSelectAllRequest(
  applicantIds: unknown,
  selectByCount?: unknown,
): boolean {
  const hasApplicantIds =
    Array.isArray(applicantIds) && applicantIds.length > 0;
  return !hasApplicantIds && !selectByCount;
}
